import { render } from "./FortigateDetails.vue?vue&type=template&id=503f9553"
import script from "./FortigateDetails.vue?vue&type=script&lang=js"
export * from "./FortigateDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__